var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.722 15.967c0 .373-.2.717-.524.905l-6.622 3.824a1.049 1.049 0 0 1-1.046 0l-6.624-3.824a1.046 1.046 0 0 1-.522-.905V8.318c0-.373.2-.718.522-.904L11.53 3.59a1.043 1.043 0 0 1 1.046 0l6.622 3.824c.324.186.524.53.524.904v7.649Zm1.326-9.777L12.71 1.376a1.312 1.312 0 0 0-1.314 0L3.057 6.19A1.313 1.313 0 0 0 2.4 7.328v9.629c0 .469.25.903.657 1.139l8.339 4.814c.407.234.907.234 1.314 0l8.338-4.814c.408-.236.657-.67.657-1.14V7.329c0-.47-.25-.904-.657-1.138Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 12.164a.973.973 0 0 0-1.304-.03l-1.693 1.46a.436.436 0 0 1-.622-.053l-2.29-2.773a.973.973 0 0 0-1.367-.132L6.258 12.74a.343.343 0 0 0-.126.266v2.066c0 .288.154.555.403.699l5.115 2.952c.25.144.556.144.806 0l5.116-2.953a.802.802 0 0 0 .402-.698v-.99a.343.343 0 0 0-.107-.25l-1.768-1.668Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.581 9.09a1.474 1.474 0 1 1-2.949 0 1.474 1.474 0 0 1 2.95 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNft);
export default __webpack_public_path__ + "static/media/NFT.9c153889.svg";
export { ForwardRef as ReactComponent };